import React from 'react';

import EditorInfoIcon from '@atlaskit/icon/glyph/editor/info';

import { Text, Wrapper } from './EmptyGadget.styled';

type Props = {
  message: string;
};
const EmptyGadget: React.FC<Props> = ({ message }: Props) => {
  return (
    <Wrapper>
      <EditorInfoIcon label='info' />
      <Text>{message}</Text>
    </Wrapper>
  );
};

export default EmptyGadget;
